import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Typography } from '@material-ui/core';
import DeleteCancel from "../../atoms/buttons/DeleteCancel";
import { invokeFileDownloadService, invokeGetService } from '../../../store/global/actions'

const ExportBlueprintFiles = (props) => {

    const dispatch = useDispatch();

    const { onClose, setOpenExportBlueprintAlert } = props


    const [loading, setLoading] = useState(false);
    const currentUrl = window.location.href;
    const [slug, blueprintID, tag, entityId] = currentUrl.split('/').slice(4);


    const onExport = () => {
        setLoading(true);
        setOpenExportBlueprintAlert(false)

        dispatch(invokeGetService('getBlueprintDetails', []))
            .then(blueprintDetails => {
                let blueprintName = blueprintDetails?.status ? blueprintDetails?.data?.name : slug
                dispatch(invokeFileDownloadService('exportBlueprintfiles', {}))
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.blob()
                    })
                    .then(blob => {
                        // Create a URL for the downloaded file
                        const url = URL.createObjectURL(blob);

                        // Trigger a download prompt
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = `${blueprintName}.zip`;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);

                        return { message: "Blueprint exported" }
                    })
                    .catch(error => {
                        console.error('Error fetching zip file', error);
                        // dispatch(handleSnackBar({ open: true, message: 'Blueprint export failed', severity: "error" }));
                        return { message: "Blueprint export failed" }
                    });
            })
    }


    return (
        <Grid container direction={"row"} spacing={1} >

            <Grid item xs={12}>
                <Typography> Do you want to export the blueprint files? </Typography>
            </Grid>

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", textTransform: 'capitalize' }} >
                <DeleteCancel onCancel={onClose} onDelete={onExport} disableButton={loading} content={loading ? 'Exporting..' : 'Export'} />
            </Grid>


        </Grid>
    )

}

export default ExportBlueprintFiles;
